import React from "react";

function Footer() {
  return (
    <footer className="px-6">
      <div className="max-w-5xl mx-auto border-t border-line pt-8 pb-12 flex items-center justify-between text-sm text-dim">
        <span>© {new Date().getFullYear()} Andreas Wallin</span>
        <a href="#top" className="hover:text-leaf transition-colors">
          Back to top
        </a>
      </div>
    </footer>
  );
}

export default Footer;
